
import { Alerte } from '@/model/alerte';
import { Article } from '@/model/article';
import { RouteName } from '@/router/routes';
import { uniqBy } from 'lodash';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { DestinatairesAlerte } from '@/model/alerte-notifications';

export default Vue.extend({
  name: 'SyntheseAlertes',
  data: () => ({
    loading: true as boolean
  }),
  computed: {
    ...mapGetters({
      alerte: 'alertes/alertesUtilisateur',
      user: 'user/user'
    }),
    username (): string | undefined {
      return this.user?.username;
    },
    alerteTriee (): Alerte[] {
      return (this.alerte as Alerte[])
        .slice()
        .sort((a, b) => a.id - b.id);
    }
  },
  created () {
    this.loadAlertes(this.username)
      .then(() => {
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions({
      loadAlertes: 'alertes/loadAlertesUtilisateur',
      suspendreAlerte: 'alertes/suspendreAlerte',
      supprimerAlerte: 'alertes/supprimerAlerte'
    }),
    articlesAlerte (alerte: Alerte) {
      return uniqBy(alerte.articleLieuDepart.map(ald => ald.article), 'id')
        .sort((a, b) => a.id - b.id);
    },
    lieuxByArticles (alerte: Alerte, article: Article) {
      return uniqBy(alerte.articleLieuDepart.filter(ald => ald.article.id === article.id).map(ald => ald.lieuDepart), 'id').map(lieu => lieu.libelle).sort().join(', ');
    },
    changeAlerteActive (alerte: Alerte) {
      this.suspendreAlerte({ utilisateur: this.username, alerte });
    },
    appelSupprimer (alerte: Alerte) {
      this.$dialog.confirm({
        title: 'Confirmation',
        text: 'Etes-vous sûr de vouloir supprimer cette alerte ?',
        actions: {
          false: {
            text: 'Annuler',
            flat: false,
            outlined: true,
            color: 'grey'
          },
          true: {
            text: 'Supprimer',
            color: 'primary',
            flat: false
          }
        }
      }).then(confirm => {
        if (confirm) {
          this.supprimerAlerte({ utilisateur: this.username, alerte });
        }
      });
    },
    newAlerte () {
      this.$router.push({
        name: RouteName.MAIN_ALERTES_EDIT,
        params: {
          idAlerte: 'new'
        }
      });
    },
    edit (alerte: Alerte) {
      this.$router.push({
        name: RouteName.MAIN_ALERTES_EDIT,
        params: {
          idAlerte: alerte.id + ''
        }
      });
    },
    unEnvoiSms (destinatairesAlerte: DestinatairesAlerte[]) {
      return destinatairesAlerte.slice()
        .filter((d: DestinatairesAlerte) => d.envoiSms1 === true || d.envoiSms2 === true);
    },
    unEnvoiMail (destinatairesAlerte: DestinatairesAlerte[]) {
      return destinatairesAlerte.slice()
        .filter((d: DestinatairesAlerte) => d.envoiEmail === true);
    }
  }
});
